<template>
  <div>
    <FieldsetModel
      :ui="uiBaseFieldset"
      :name="fieldsetNameComp"
      :ui-title="title"
      :ui-subtitle="subtitle"
      :ui-columns="columns"
    >
      <UiWrapper
        :name="FIELD_NAMES.firstName"
        :label="firstNameLabel"
        :default-value="getValueFromCookie('nbc', 'firstName')"
        :validations="[
          {
            'errorMessage': 'Field contains invalid characters',
            'condition': patternCondition(NAMES_CHARS),
            'name': 'name-chars',
          },
        ]"
      >
        <InputText />
      </UiWrapper>

      <UiWrapper
        :name="FIELD_NAMES.lastName"
        :label="lastNameLabel"
        :validations="[
          {
            'errorMessage': 'Field contains invalid characters',
            'condition': patternCondition(NAMES_CHARS),
            'name': 'lastname-chars',
          },
        ]"
      >
        <InputText />
      </UiWrapper>
    </FieldsetModel>
  </div>
</template>

<script>
import { InputText } from '@dunia/ui';
import { patternCondition } from '@/forms/conditions';
import {
  NAMES_CHARS,
} from '@/forms/constants/onboarding-logic';
import sharedComponentMixin from '@/forms/components/shared/shared-component-mixin';
import getValueFromCookie from '@/forms/helpers/get-value-from-cookie';

export default {
  name: 'FieldsetFullName',

  props: {
    title: {
      type: String,
      default: 'Your full name',
    },
    fieldsetName: {
      type: String,
    },
    subtitle: {
      type: String,
      default: '',
    },
    firstNameLabel: {
      type: String,
      default: 'First name',
    },
    lastNameLabel: {
      type: String,
      default: 'Last name',
    },
    columns: {
      type: String,
      default: '2',
    },
  },

  mixins: [sharedComponentMixin],

  data: () => ({
    NAMES_CHARS,
  }),

  methods: {
    getValueFromCookie,
    patternCondition,
  },

  components: {
    InputText,
  },

  computed: {
    fieldsetNameComp() {
      if (this.fieldsetName) {
        return this.fieldsetName;
      }

      return this.FIELDSET_NAMES.fullName;
    },
  },
};
</script>
